import HttpRequest from './httpRequest'

export default class ProductProvider extends HttpRequest {
  fetchProducts () {
    return this.fetch('/products')
  }
}
